import { render } from "./base-otp-input.vue?vue&type=template&id=58627753&ts=true"
import script from "./base-otp-input.vue?vue&type=script&lang=ts"
export * from "./base-otp-input.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__